import { ACCESS_EMBEDDED_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import CTA from "components/ui/CTA"

function SingleCTASection() {
  const { getAsset } = usePageAssets()
  const background = getAsset("single-cta-preset-background")
  return (
    <Container section>
      <CTA
        background={background}
        label="Get in Touch"
        title="Talk to our team to ask questions and test out Preset’s embedded dashboards"
        linkText="Request Access"
        linkUrl={ACCESS_EMBEDDED_URL}
        trackClick="Request Access (cta)_Embedded Dashboards"
        size="wide"
        dark
      />
    </Container>
  )
}

export default SingleCTASection
